import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import LinearProgress from "@mui/material/LinearProgress";
import {
  FormGroup,
  FormControlLabel,
  Switch,
  TextField,
  MenuItem,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
} from "@mui/material";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {
  getPickupSettings,
  postPickupSettings,
  resetPickupSettingsState,
} from "./pickupSettingsSlice";
import { fetchCountry, fetchState } from '../../../pages/General/countryStateCitySlice';
import Notification from '../../../pages/General/Notification';

const PickupSettingsPage = () => {
  const dispatch = useDispatch();
  const [alert, setAlert] = useState(false);
  const [open, setOpen] = useState(false);
  const pickupsettings = useSelector((state) => state.pickupsettings);
  const profile = useSelector(state => state.auth.profile);    
  const country = useSelector(state => state.countrystate.country);
  const state = useSelector(state => state.countrystate.state);
  const timeOptions = Array.from({ length: 24 }, (_, i) => `${i.toString().padStart(2, '0')}:00`);
  const initialValues = {
        pickup: false,
        name: '',
        address: '',
        address2: '',
        city: '',
        company: '',
        country_code: '',
        email: '',
        phone: '',
        postal_code: '',
        state_code: '',
        start_time:'',
        end_time:''
    }

  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const onLabelChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: e.target.checked,
    });
  };

  const handleInputChange = e => {
        const { name, value } = e.target
        if(e.target.name === 'postal_code'){
            setValues({
                ...values,
                [name]: value.replace(/\s/g, ''),
            });
       }else{
            setValues({
                ...values,
                [name]: value
            })
        }
        // if (validateOnChange)
        //     validate({ [name]: value })
    }

  const validateFields = () => {
  const newErrors = {};

  if (!values.pickup) return newErrors; // Skip validation if pickup is false

  // Required text fields
  const requiredFields = [
    'name',
    'company',
    'phone',
    'email',
    'address',
    'postal_code',
    'city',
    'country_code',
    'state_code',
    'start_time',
    'end_time',
  ];

  requiredFields.forEach((field) => {
    if (!values[field]) {
      newErrors[field] = 'This field is required';
    }
  });

  // Email format
  if (values.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
    newErrors.email = 'Invalid email format';
  }

  // Phone format (basic numeric check)
  if (values.phone && !/^\d{6,20}$/.test(values.phone)) {
    newErrors.phone = 'Invalid phone number';
  }

  // Time logic
  const start = dayjs(values.start_time, 'HH:mm');
  const end = dayjs(values.end_time, 'HH:mm');
  if (start.isValid() && end.isValid() && !start.isBefore(end)) {
    newErrors.start_time = 'Start time must be earlier than end time';
    newErrors.end_time = 'End time must be later than start time';
  }

  return newErrors;
};

const handleFieldBlur = (e) => {
  const { name, value } = e.target;
  const newErrors = { ...errors };

  // Basic required field check
  if (!value.trim()) {
    newErrors[name] = 'This field is required';
  } else {
    delete newErrors[name];

    // Optional: add format checks
    if (name === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      newErrors[name] = 'Invalid email format';
    }

    if (name === 'phone' && !/^\d{6,20}$/.test(value)) {
      newErrors[name] = 'Invalid phone number';
    }
  }

  setErrors(newErrors);
};



const handleSubmit = (e) => {
  e.preventDefault();

  const validationErrors = validateFields();
  setErrors(validationErrors);

  if (Object.keys(validationErrors).length === 0) {
    const finalData = {
      is_enabled: values.pickup,
      address: {
        name: values.name,
        company: values.company,
        phone: values.phone,
        email: values.email,
        address: values.address,
        address2: values.address2,
        postal_code: values.postal_code,
        city: values.city,
        country_code: values.country_code,
        state_code: values.state_code,
      },
      start_time: values.start_time,
      end_time: values.end_time,
    };

    dispatch(postPickupSettings(profile && profile.id,finalData));
    // You can now send finalData to your backend or next step
  }
};


useEffect(() => {
  const config = pickupsettings?.data;

  if (config && config.address) {
    dispatch(fetchState(config.address.country_code));
    setValues({
      pickup: config.is_enabled || false,
      start_time: config.start_time || '',
      end_time: config.end_time || '',
      name: config.address.name || '',
      company: config.address.company || '',
      phone: config.address.phone || '',
      email: config.address.email || '',
      address: config.address.address || '',
      address2: config.address.address2 || '',
      postal_code: config.address.postal_code || '',
      city: config.address.city || '',
      country_code: config.address.country_code || '',
      state_code: config.address.state_code || '',
    });
  }
}, [pickupsettings]);


  const handleClose = () => {
    setOpen(false);
    dispatch(resetPickupSettingsState());
  };

  useEffect(() => {
    dispatch(getPickupSettings());
  }, []);

   useEffect(() => {
      dispatch(fetchCountry());
   }, [dispatch]);
  const filteredCountryData = country.data.filter(({ code }) => code );
   
  const onSelectCountryChange = (countryCode) => {
      setValues({
        ...values,
        country_code: countryCode,
      });
      setErrors({ country_code: "" });
      dispatch(fetchState(countryCode));
    };
  const getSelectedCountry = (country_code) => {
      let filteredValue = { code: "", name: "" };
      filteredCountryData.map((key) => {
        if (key.code == country_code) {
          filteredValue = key;
        }
      });
      return filteredValue;
    };
  
    const onSelectStateChange = (currentstate) => {
      setValues({
        ...values,
        state_code: currentstate,
      });
      setErrors({ state_code: "" });
    };
  
    const getSelectedState = (currentstate) => {
      let filteredStateValue = { code: "", name: "" };
      let tempState = "";
      state &&
        state.data &&
        state.data.map((key) => {
          if (key.code == currentstate && tempState == "") {
            filteredStateValue = key;
            tempState = "success";
          }
        });
      return filteredStateValue;
    };
  return (
    <div className="sc--settings--card">
      {(pickupsettings && pickupsettings.notification && pickupsettings.notification.messageContent!='') &&
            <Notification
                is_open={pickupsettings.notification.show}
                messageType={pickupsettings.notification.messageType}
                messages={pickupsettings.notification.messageContent}
                handleClose={() => dispatch(resetPickupSettingsState())}
       />}
      <Card
        sx={{ minWidth: '100%', boxShadow: "unset" }}
        className="sc--cardhead--details"
      >
        <CardHeader title="Pickup Settings" className="sc--cardhead--details" />
        {pickupsettings && pickupsettings.loading === true && (
          <LinearProgress />
        )}
        <Divider />
        {pickupsettings && pickupsettings.loading === false && (
          <CardContent className="sc--label--settings">
            <div className="sc--form--center" style={{justifyContent:'left'}}>
              <FormGroup className="sc--label--settings--label">
                <FormControlLabel
                  control={
                    <Switch
                      checked={values.pickup}
                      name="pickup"
                      onChange={onLabelChange}
                    />
                  }
                  label="Pick up"
                  labelPlacement="start"
                />
                </FormGroup>
              </div>
              <div className="sc--form--center">
                <TextField
                  label="Name*"
                  name="name"
                  type="text"
                  value={values.name}
                  onChange={handleInputChange}
                  inputProps={{ maxLength: 40 }}
                  error={!!errors.name}
                  helperText={errors.name}
                  onBlur={handleFieldBlur}
                  style={{ width: "100%", margin: '8px' }}
                  variant="standard"
                  disabled={!values.pickup}
                />
                <TextField
                  label="Company*"
                  name="company"
                  type="text"
                  value={values.company}
                  onChange={handleInputChange}
                  inputProps={{ maxLength: 40 }}
                  error={!!errors.company}
                  helperText={errors.company}
                  onBlur={handleFieldBlur}
                  variant="standard"
                  style={{ width: "100%", margin: '8px' }}
                  disabled={!values.pickup}
                />
              </div>

              <div className="sc--form--center">
                <TextField
                  label="Phone*"
                  name="phone"
                  value={values.phone}
                  onChange={handleInputChange}
                  inputProps={{ maxLength: 20 }}
                  error={!!errors.phone}
                  helperText={errors.phone}
                  onBlur={handleFieldBlur}
                  variant="standard"
                  style={{ width: "100%", margin: '8px' }}
                  disabled={!values.pickup}
                />
                <TextField
                  label="Email*"
                  name="email"
                  type="email"
                  value={values.email}
                  inputProps={{ maxLength: 60 }}
                  onChange={handleInputChange}
                  error={!!errors.email}
                  helperText={errors.email}
                  onBlur={handleFieldBlur}
                  variant="standard"
                  style={{ width: "100%", margin: '8px' }}
                  disabled={!values.pickup}
                />
              </div>

              <div className="sc--form--center">
                <TextField
                  label="Address1*"
                  name="address"
                  value={values.address}
                  inputProps={{ maxLength: 35 }}
                  onChange={handleInputChange}
                  error={!!errors.address}
                  helperText={errors.address}
                  onBlur={handleFieldBlur}
                  variant="standard"
                  style={{ width: "100%", margin: '8px' }}
                  disabled={!values.pickup}
                />
                <TextField
                  label="Address2"
                  name="address2"
                  value={values.address2}
                  inputProps={{ maxLength: 35 }}
                  onChange={handleInputChange}
                  error={!!errors.address2}
                  helperText={errors.address2}
                  onBlur={handleFieldBlur}
                  variant="standard"
                  style={{ width: "100%", margin: '8px' }}
                  disabled={!values.pickup}
                />
              </div>

              <div className="sc--form--center">
                <TextField
                  label="Postal Code*"
                  name="postal_code"
                  value={values.postal_code}
                  onChange={handleInputChange}
                  inputProps={{ maxLength: 10 }}
                  error={!!errors.postal_code}
                  helperText={errors.postal_code}
                  onBlur={handleFieldBlur}
                  variant="standard"
                  style={{ width: "100%", margin: '8px' }}
                  disabled={!values.pickup}
                />
                <TextField
                  label="City*"
                  name="city"
                  value={values.city}
                  inputProps={{ maxLength: 30 }}
                  onChange={handleInputChange}
                  error={!!errors.city}
                  helperText={errors.city}
                  onBlur={handleFieldBlur}
                  variant="standard"
                  style={{ width: "100%", margin: '8px' }}
                  disabled={!values.pickup}
                />
              </div>

              <div className="sc--form--center">
                <Autocomplete
                  className="help-text-error"
                  disablePortal
                  name="country_code"
                  id="country-select-demo"
                  sx={{ width: "100%", margin: '8px' }}
                  options={filteredCountryData}
                  autoHighlight
                  loading={country && country.loading}
                  getOptionLabel={(option) => option.name}
                  value={getSelectedCountry(values.country_code)}
                  disabled={!values.pickup}
                  renderOption={(props, option) => (
                    <MenuItem {...props} value={option.code} key={option.code}>
                      {option.icon} {option.name}
                    </MenuItem>
                  )}
                  onChange={(event, value) => {
                    if (value !== null) {
                      onSelectCountryChange(value.code);
                      setErrors({ country_code: "" });
                    } else {
                      onSelectCountryChange("");
                      setErrors({ country_code: "This field is required" });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Country*"
                      variant="standard"
                      helperText={errors.country_code}
                      onBlur={handleFieldBlur}
                      disabled={!values.pickup}
                    />
                  )}
                />

                <Autocomplete
                  className="help-text-error"
                  disablePortal
                  name="state_code"
                  id="state-select-demo"
                  sx={{ width: "100%", margin: '8px' }}
                  options={state?.data || []}
                  autoHighlight
                  loading={state?.loading || country?.loading}
                  getOptionLabel={(option) => option.name}
                  value={getSelectedState(values.state_code)}
                  disabled={!values.pickup}
                  renderOption={(props, option) => (
                    <MenuItem {...props} value={option.code} key={option.code}>
                      {option.name}
                    </MenuItem>
                  )}
                  onChange={(event, value) => {
                    if (value !== null) {
                      onSelectStateChange(value.code);
                    } else {
                      onSelectStateChange("");
                      setErrors({ state_code: "This field is required" });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="State*"
                      variant="standard"
                      helperText={errors.state_code}
                      onBlur={handleFieldBlur}
                      disabled={!values.pickup}
                    />
                  )}
                />
              </div>

              {/* Start and End Time Fields */}
              <div className="sc--form--center">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <FormControl
                    variant="standard"
                    className="help-text-error"
                    style={{ width: '60%', margin: '8px' }}
                    disabled={!values.pickup}
                  >
                    <TimePicker
                      label="Start Time*"
                      value={values.start_time ? dayjs(values.start_time, 'HH:mm') : null}
                      disabled={!values.pickup}
                      onChange={(newValue) => {
                        const formatted = newValue ? newValue.format('HH:mm') : '';
                        handleInputChange({ target: { name: 'start_time', value: formatted } });

                        if (formatted) {
                          setErrors((prev) => {
                            const updated = { ...prev };
                            delete updated.start_time;
                            return updated;
                          });
                        }
                      }}
                      ampm={false}
                      renderInput={(params) => (
                        <TextField
                          variant="standard"
                          {...params}
                          error={!!errors.start_time}
                          helperText={errors.start_time}
                          disabled={!values.pickup}
                        />
                      )}
                    />
                  </FormControl>

                  <FormControl
                    variant="standard"
                    className="help-text-error"
                    style={{ width: '60%', margin: '8px' }}
                    disabled={!values.pickup}
                  >
                    <TimePicker
                      label="End Time*"
                      value={values.end_time ? dayjs(values.end_time, 'HH:mm') : null}
                      disabled={!values.pickup}
                      onChange={(newValue) => {
                        const formatted = newValue ? newValue.format('HH:mm') : '';
                        handleInputChange({ target: { name: 'end_time', value: formatted } });

                        if (formatted) {
                          setErrors((prev) => {
                            const updated = { ...prev };
                            delete updated.end_time;
                            return updated;
                          });
                        }
                      }}
                      ampm={false}
                      renderInput={(params) => (
                        <TextField
                          variant="standard"
                          {...params}
                          error={!!errors.end_time}
                          helperText={errors.end_time}
                          disabled={!values.pickup}
                        />
                      )}
                    />
                  </FormControl>
                </LocalizationProvider>
              </div>

            <div className="sc--form--center" style={{justifyContent:'center'}}>
              <Button
                variant="outlined"
                onClick={handleSubmit}
                // disabled={!values.pickup}
                style={{ margin: "15px 15px" }}
              >
                Save
              </Button>
            </div>
          </CardContent>
        )}
      </Card>
    </div>
  );
};

export default PickupSettingsPage;
